import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { apiRegisUser } from '../../services/api/register';

import Swal from "sweetalert2";
import { fas } from "@fortawesome/free-solid-svg-icons";
import './style/user.scss';


library.add(fas);





class User extends Component {

    constructor(props) {
        super(props);

        this.state = {
            first_name: "",
            last_name: "",
            address: "",
            district: "",
            sub_district: "",
            province: "",
            zipcode: "",
            tel: "",
            email: "",
            username: "",
            password: "",
            repassword: ""

        };
    }


    regis = async () => {
        // console.log(this.state)
        if(this.state.password == this.state.repassword){
            let data = {
                "username" : this.state.username,
                "password" : this.state.password,
                "first_name" : this.state.first_name,
                "last_name" : this.state.last_name,
                "address_no" : this.state.address,
                "district" : this.state.district,
                "sub_district" : this.state.sub_district,
                "province" : this.state.province,
                "post_code" : this.state.zipcode,
                "mobile" : this.state.tel,
                "email" : this.state.email
            }

            let resCreate = await apiRegisUser(data)
        if (resCreate && resCreate.status) {
            if (resCreate.status == 200) {
                Swal.fire({
                    title: 'Succcess!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 1000
                })

                setTimeout(() => { window.location.href = "/auth"}, 1000)

            } 
        }else{
            Swal.fire({
                title: 'Error!',
                text: resCreate.message,
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            })
        }


        }else{
            Swal.fire({
                title: 'Error!',
                text: "รหัสผ่านไม่ตรงกัน",
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            })
        }
        
    }


    render() {




        return (
            <div className="cover-create">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                <div className="box-create">
                    <div className="row half-box">
                        <div className="col-lg-4 col-md-4 col-12 col-img-store">
                            <div className="grid-ta">
                                <div className="box-ver">
                                    <div className="img-login">
                                        <img className="img-fluid" src="/img/pic/store.png" />
                                    </div>
                                    <div className="btn-create">
                                        <a className="link-create" type="button" href="/create_store">เปิดบัญชีร้านค้า</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-12 col-register">
                            <div className="hd-des">
                                <a href="/auth" className="back-login"><FontAwesomeIcon icon={['fas', 'chevron-left']} /></a>
                                <p className="txt">สร้างบัญชีใหม่ !</p>
                            </div>

                            <div className="form-register">
                                <div className="data-regis">
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <input type="text" onChange={(e)=>{this.setState({first_name: e.target.value})}} className="form-control" placeholder="ชื่อ" />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <input type="text" onChange={(e)=>{this.setState({last_name: e.target.value})}} className="form-control" placeholder="นามสกุล" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" onChange={(e)=>{this.setState({address: e.target.value})}} className="form-control" placeholder="ที่อยู่" />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <input type="text" onChange={(e)=>{this.setState({district: e.target.value})}} className="form-control" placeholder="อำเภอ" />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input type="text" onChange={(e)=>{this.setState({sub_district: e.target.value})}} className="form-control" placeholder="เขต" />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input type="text" onChange={(e)=>{this.setState({province: e.target.value})}} className="form-control" placeholder="จังหวัด" />
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <input type="number" maxLength={5} onChange={(e)=>{this.setState({zipcode: e.target.value})}} className="form-control" placeholder="รหัสไปรษณีย์" />
                                        </div>
                                        <div className="form-group col-md-8">
                                            <input type="number" maxLength={10} onChange={(e)=>{this.setState({tel: e.target.value})}} className="form-control" placeholder="เบอร์มือถือ" />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <input type="email" onChange={(e)=>{this.setState({email: e.target.value})}} className="form-control" placeholder="อีเมล" />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <input type="text" onChange={(e)=>{this.setState({username: e.target.value})}} className="form-control" placeholder="ชื่อผู้ใช้" />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <input type="password" onChange={(e)=>{this.setState({password: e.target.value})}} className="form-control" placeholder="รหัสผ่าน" />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <input type="password" onChange={(e)=>{this.setState({repassword: e.target.value})}} className="form-control" placeholder="ยืนยันรหัสผ่าน" />
                                        </div>
                                    </div>
                                    <button onClick={()=>{this.regis()}} className="btn btn-primary">สมัครสมาชิก</button>
                                </div>

                                <p className="create-account">หรือ มีบัญชีอยู่แล้วและต้องการเข้าสู่ระบบ <a href="/auth" className="link-create">เข้าสู่ระบบ</a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default User;
